// extracted by mini-css-extract-plugin
module.exports = {"message-text":"message-text__4m75x","message-text--system":"message-text--system__mdDfo"};